import CookieConsent, { Cookies } from 'react-cookie-consent';

export function gdprEmbeddedCheck() {
	const getHostname = (url) => {
		const a = document.createElement('a');
		a.href = url;
		return a.hostname;
	};
	const fr = document.getElementsByTagName('iframe');

	for (const frame of fr) {
		const timer = setTimeout(() => { // Firefox workaround - content disapears without setTimeout
			const frWindow = frame.contentWindow;
			const frDocument = frWindow.document;
			const url = frame.getAttribute('data-src');
			const consent = frame.getAttribute('data-consent') != null ? frame.getAttribute('data-consent') : true;

			if (consent === "0") {
				frame.setAttribute('src', url)
				return
			}

			if (Cookies.get('djn47-gdpr') === 'true' || Cookies.get('djn47-gdpr') === true) {
				frame.setAttribute('src', url);
			} else {
				const body = frDocument.body;
				const blur = frDocument.createElement('div');
				blur.style = `
					background-size: cover;
					position: absolute;
					background: rgba(0,0,0,0.5);
					top: 0; bottom: 0; left: 0; right: 0;
				`;
				const noticeWrapper = frDocument.createElement('div');
				noticeWrapper.style = `
					position: absolute;
					top: 50%; left: 50%;
					color: #B6B6B6;
					transform: translate(-50%, -50%);
					width: 100%;
					text-align: center;
					font-size: 13px;
				`;

				const noticeHeader = frDocument.createElement('h1');
				noticeHeader.style = `font-size: 20px`;
				noticeHeader.innerHTML = `
					This content may load
					${frame.getAttribute('data-service-provider-name') || getHostname(url)} cookies
				`;

				const noticeInfo = frDocument.createElement('p');
				noticeInfo.style = `
					margin: 0 5px 13px 5px;
				`;
				// noticeInfo.innerHTML = `
				// 	By accepting you will be accessing a service provided by a third-party
				// 	external to ${window.location.hostname}
				// `;
				noticeInfo.innerHTML = `
					Pour lire le contenu de ${frame.getAttribute('data-service-provider-name') || getHostname(url)}, vous devez accepter l'utilisation de cookies marketing.
				`;

				const noticeButton = frDocument.createElement('button');
				noticeButton.style = `
					display: block;
					float: right;
					font-size: 13px;
				`;
				noticeButton.innerHTML = 'Accepter et lire le média';
				noticeButton.style = `
					text-decoration: none;
					text-transform: uppercase;
					background-color: #dd0000;
					line-height: 28px;
					padding: 0 6px;
					border: 0px none;
					color: #FFFFFF;
					cursor: pointer;
					font-size: 11px;
				`;
				noticeButton.onclick = () => {
					Cookies.set('djn47-gdpr', true, { expires: 365, path: '/', secure: true });
					Cookies.set('djn47-gdpr', true, { expires: 365, path: '/', secure: true });
					if (document.getElementsByClassName('container-djn47-gdpr').length > 0) {
						document.getElementsByClassName('container-djn47-gdpr')[0].style.visibility = 'hidden';
					}
					for (const frame2 of fr) {
						frame2.setAttribute('src', frame2.getAttribute('data-src'));
						// frame.setAttribute('src', url);
					}
				};

				const noticeSecondary = frDocument.createElement('a');
				noticeSecondary.style = `
					color: #dd0000;
					text-decoration: none;
					display: block;
					margin-top: 13px;
				`;
				// noticeSecondary.href = url;
				noticeSecondary.href = '/politique-de-cookies';
				noticeSecondary.target = '_blank';
				noticeSecondary.rel = 'noopener';
				noticeSecondary.innerHTML = 'Lire la politique de cookies';

				// noticeWrapper.appendChild(noticeHeader);
				noticeWrapper.appendChild(noticeInfo);
				noticeWrapper.appendChild(noticeButton);
				noticeWrapper.appendChild(noticeSecondary);

				body.style = `font-family: Lato, sans-serif`;
				body.appendChild(blur);
				body.appendChild(noticeWrapper);
			}

		}, 500);
	}
}

export function gdprCookieManagementPage() {
	const radioDecline = document.querySelectorAll('#cookie_decline')[0];
	const radioAccept = document.querySelectorAll('#cookie_accept')[0];

	console.log(radioDecline)
	console.log(radioAccept)

	if (Cookies.get('djn47-gdpr') === 'true' || Cookies.get('djn47-gdpr') === true) {
		radioDecline.removeAttribute('checked');
		radioAccept.setAttribute('checked', 'checked');
	} else {
		radioAccept.removeAttribute('checked');
		radioDecline.setAttribute('checked', 'checked');
	}

	radioDecline.addEventListener('click', (e) => {
		Cookies.set('djn47-gdpr', false, { expires: 365, path: '/', secure: true });
		Cookies.set('djn47-gdpr', false, { expires: 365, path: '/', secure: true });
	}, false);

	radioAccept.addEventListener('click', (e) => {
		Cookies.set('djn47-gdpr', true, { expires: 365, path: '/', secure: true });
		Cookies.set('djn47-gdpr', true, { expires: 365, path: '/', secure: true });
	}, false);
}
